export enum ContextsSuggestions {
  Name = "name",
  Slug = "slug",
  Space = "space",
}

export const SEARCH_CONTEXTS_SUGGESTIONS_DICTIONARY: Record<string, string> = {
  [ContextsSuggestions.Space]: "space",
  [ContextsSuggestions.Name]: "name",
  [ContextsSuggestions.Slug]: "ID",
};

export const SORT_ITEM_ORDER = ["name", "space", "createdAt"];
